import { Dispatch } from 'redux';
import { Logger } from '../utils/';
import { HomeWorkoutSequence } from 'fitbeat.gym-core';
import moment from 'moment';
import { isBookingForGroupWorkout } from '../Bookings/utils/BookingUtils';

export function makeApiRequestAction<T extends (...args: any[]) => any>(
  types: IApiRequestTypes,
  originalAction: T): (...funcArgs: Parameters<T>) => any {

  return (...args: Parameters<T>): any => {
    return async (dispatch: Dispatch<any>, getState: any) => {
      try {
        dispatch({
          type: types.requestType,
        });
        await originalAction(...args, dispatch, getState);
      } catch (error) {
        Logger.notify(error);
        dispatch({
          type: types.failureType,
          payload: error,
        });
      }
    };
  };
}

interface IApiRequestTypes {
  requestType: string;
  failureType: string;
}

export function workoutSummaryHeaderStartText(
  homeWorkoutStartTime: Date,
  t: (key: string, option?: any) => string,
  isGroupWorkout: boolean,
): string {
  const workoutStartTime = moment(homeWorkoutStartTime);
  const now = moment.now();
  const classStartsInSeconds = workoutStartTime.diff(now, 'seconds');

  if (classStartsInSeconds >= 0 && classStartsInSeconds <= 60) {
    return t('startingNow');
  }
  if (classStartsInSeconds < 0) {
    if (isGroupWorkout) {
      return t('classStarted');
    }
    return t('startingNow');
  }
  return workoutStartTime.format('D MMM, HH:mm');
}